export default __webpack_public_path__ + "static/media/store_svg15.ac958350.svg";